exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.feature-walkthrough{display:flex;align-items:center;flex-direction:column;justify-content:flex-end;position:absolute;top:0;bottom:0;height:100%;width:100%;opacity:1;background-color:#fff;z-index:1}.feature-walkthrough--closing{opacity:0;transition:opacity .5s}.feature-walkthrough__img{position:absolute;bottom:230px;max-height:calc(100% - 275px);max-width:100%;min-width:100px;object-fit:contain}.feature-walkthrough__text{display:flex;align-items:center;color:#184e78;max-height:60px;margin:12px 21px 30px;flex-grow:2;font-family:Oswald,sans-serif;text-align:center;white-space:pre-line}.feature-walkthrough__text h3{font-weight:400;margin:0;font-size:20px;line-height:30px}.feature-walkthrough__nav{display:flex;align-items:center;margin:0;height:12px}.feature-walkthrough__nav .nav-dot{border-radius:50%;height:12px;width:12px;background-color:#d8d8d8;margin-right:8px}.feature-walkthrough__nav .nav-dot--active{background-color:#184e78}.feature-walkthrough__nav .nav-dot:last-child{margin-right:0}.feature-walkthrough__skip-button{cursor:pointer;margin-top:8px;margin-bottom:56px;height:28px;font-family:Oswald,sans-serif;font-size:12px;font-weight:300;color:#184e78}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/FeatureWalkthrough/FeatureWalkthrough.scss
// module id = 1705
// module chunks = 0